export const CURRENT_PROJECT_STORAGE_KEY = 'geobot_current_project_id';
export const CURRENT_PROJECT_COOKIE_NAME = 'geobot_current_project_id';
const CURRENT_PROJECT_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

function readProjectSelectionCookie(cookieString: string): string | null {
  const cookiePrefix = `${CURRENT_PROJECT_COOKIE_NAME}=`;
  const cookieValue = cookieString
    .split(';')
    .map(part => part.trim())
    .find(part => part.startsWith(cookiePrefix));

  if (!cookieValue) {
    return null;
  }

  const rawValue = cookieValue.slice(cookiePrefix.length);
  return rawValue ? decodeURIComponent(rawValue) : null;
}

export function getPersistedCurrentProjectId(): string | null {
  if (typeof document !== 'undefined') {
    const cookieValue = readProjectSelectionCookie(document.cookie);
    if (cookieValue) {
      return cookieValue;
    }
  }

  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage.getItem(CURRENT_PROJECT_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function persistCurrentProjectId(projectId: string | null) {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return;
  }

  try {
    if (projectId) {
      window.localStorage.setItem(CURRENT_PROJECT_STORAGE_KEY, projectId);
    } else {
      window.localStorage.removeItem(CURRENT_PROJECT_STORAGE_KEY);
    }
  } catch {
    // Ignore localStorage failures in restricted browser contexts.
  }

  if (projectId) {
    document.cookie =
      `${CURRENT_PROJECT_COOKIE_NAME}=${encodeURIComponent(projectId)}; ` +
      `Max-Age=${CURRENT_PROJECT_COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax`;
    return;
  }

  document.cookie = `${CURRENT_PROJECT_COOKIE_NAME}=; Max-Age=0; Path=/; SameSite=Lax`;
}
